<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Búsqueda de especificaciones</h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <table class="table table-striped table-bordered table-sm row-border hover nowrap" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger">
        <thead>
            <tr>
                <th> Código </th>
                <th> Descripción </th>
               
            </tr>
        </thead>
        <tbody>
            <tr class="cursor" *ngFor="let lst of clasesSelectEspecificaciones" (click)="onClick(lst)">
                <td>{{lst.codigo}}</td>
                <td style="text-align: left;">{{lst.descri}}</td>
                
            </tr>
        </tbody>
    </table>
</div>